export default "__VITE_ASSET__DSUwh2Ik__"